<template>
  <div class="organization-main">
    <router-view />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.organization-main {
  height: 100vh;
  width: 100%;
  max-width: 10rem;
}
</style>
